import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { RouteReuseStrategy } from '@angular/router';

import { IonicModule, IonicRouteStrategy } from '@ionic/angular';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';

// ReactiveForms
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

// NgCharts
import { NgChartsModule } from 'ng2-charts';
import { HttpClientModule } from '@angular/common/http';

import { DailyImporterV21Page } from './pages/daily-importer-v2.1/daily-importer.page';
import { DailyImporterPage } from './pages/daily-importer-v2/daily-importer-old.page';
import { IonicSelectableModule } from 'ionic-selectable';
import { DailyImporterV3Page } from './pages/daily-importer-v3/daily-importer-v3.page';
import { ModalUploaderComponent } from './components/model-uploader/modal-uploader.component';
import { DndDirective } from './directives/dnd.directive';
import { ProgressComponent } from './components/progress/progress.component';
import { ManagerUploaderPage } from './pages/manager-uploader/manager-uploader.page';
import { ModalDailyReportComponent } from './components/modal-daily-report/modal-daily-report.component';
import { PoViewerComponent } from './components/po-viewer/po-viewer.component';
@NgModule({
  declarations: [AppComponent, DailyImporterV21Page, DailyImporterPage, DailyImporterV3Page, ModalUploaderComponent,DndDirective,ProgressComponent, ManagerUploaderPage, ModalDailyReportComponent, PoViewerComponent],
  entryComponents: [],
  imports: [
    BrowserModule,
    IonicModule.forRoot(),
    IonicSelectableModule,
    FormsModule,  
    ReactiveFormsModule,
    AppRoutingModule,
    NgChartsModule,
    HttpClientModule,
    
  ],
  providers: [{ provide: RouteReuseStrategy, useClass: IonicRouteStrategy }],
  bootstrap: [AppComponent],
})
export class AppModule { }
